export enum Partner {
    AAFES = 'aafes',
    Altice = 'altice',
    Amazon = 'amazon',
    AppliancePlus = 'appliance-plus',
    ArmstrongMcCall = 'armstrongmccall',
    Asurion = 'asurion', // should redirect to Soluto
    Att = 'att',
    BackMarket = 'backmarket',
    BJs = 'bjs',
    Blains = 'blains',
    CGX = 'cgx',
    Clyde = 'clyde',
    CosmoProf = 'cosmoprof',
    Cox = 'cox',
    Cricket = 'cricket',
    DirecTV = 'directv',
    Dish = 'dish',
    DSG = 'dsg',
    FieldStream = 'fieldstream',
    Fingerhut = 'fingerhut',
    Gettington = 'gettington',
    GolfGalaxy = 'golfgalaxy',
    GuitarCenter = 'guitarcenter',
    HomePro = 'homepro',
    JCP = 'jcp',
    Koodo = 'koodo',
    LGElectronics = 'lgelectronics',
    Liberty = 'liberty',
    MCX = 'mcx',
    Meijer = 'meijer',
    MyTechHero = 'mytechhero', // AE dev
    NEX = 'nex',
    Optimum = 'optimum',
    Overstock = 'overstock',
    PayCheckDirect = 'paycheckdirect',
    Quill = 'quill',
    Reach = 'reach',
    SallyBeauty = 'sallybeauty',
    Samsung = 'samsung',
    ServiceBench = 'servicebench',
    Shopko = 'shopko',
    SimplrQA = 'simplr-qa',
    Soluto = 'soluto',
    Sprint = 'sprint',
    Staples = 'staples',
    Telus = 'telus',
    TelusHomePro = 'telushomepro', // should redirect to HomePro
    THD = 'thd',
    TheSource = 'thesource',
    TSC = 'tsc',
    USCellular = 'uscellular',
    VCS = 'vcs',
    Verizon = 'verizon',
    VerizonQA = 'verizon-qa',
    Vip = 'vip',
    // For E2E Tests
    SdkE2E = 'sdk-e2e-test',
    WorkspaceE2E = 'workspace-e2e-test',
}
